import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { SEO } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Motion";
import { CITIES, COUNTIES } from "../data/cities";

const AreasHub = () => (
  <main data-testid="areas-hub-page">
    <SEO
      title="Service Areas: Fort Worth, Tarrant & Parker County, TX | Mobile Welding"
      description="Mobile welding repair across 18 cities in Tarrant & Parker County, TX — Fort Worth to Weatherford and Mineral Wells. Find your city for response times and services."
    />
    <PageHero
      kicker="Service area · Tarrant & Parker County"
      title="From downtown Fort Worth to the Mineral Wells ranch gate"
      lede="Two counties, one rig, no out-of-area games. Pick your city for response times and the repairs we handle there most."
      testidPrefix="areas-hub"
    />
    <section className="bg-paper pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {COUNTIES.map((county) => (
          <div key={county.slug} className="mb-14" data-testid={`county-group-${county.slug}`}>
            <Reveal>
              <div className="flex flex-wrap items-baseline justify-between gap-3 border-b-2 border-ink/70 pb-4 mb-6">
                <h2 className="font-display font-black tracking-tight text-2xl sm:text-3xl">{county.name}</h2>
                <Link to={`/service-areas/${county.slug}`} data-testid={`county-link-${county.slug}`} className="group inline-flex items-center gap-2 font-bold text-rust hover:text-rust-dark transition-colors text-sm">
                  County overview <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden />
                </Link>
              </div>
            </Reveal>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-warmline border border-warmline">
              {CITIES.filter((c) => c.county.includes(county.name.split(" ")[0])).map((c, i) => (
                <Reveal key={c.slug} delay={(i % 3) * 0.06}>
                  <Link to={`/service-areas/${c.slug}`} data-testid={`city-card-${c.slug}`} className="group block bg-cream hover:bg-sand transition-colors duration-200 p-6 h-full">
                    <div className="flex items-center gap-2 mb-2">
                      <MapPin size={16} className="text-rust" aria-hidden />
                      <h3 className="font-display font-extrabold text-xl tracking-tight group-hover:text-rust transition-colors">{c.name}</h3>
                    </div>
                    <p className="text-sm font-semibold text-steel">{c.tag}</p>
                    <p className="mt-2 text-sm text-smoke">On-site {c.response}</p>
                  </Link>
                </Reveal>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  </main>
);

export default AreasHub;
